import type { FileObject } from '@components/ui/DropZone/DropZone.types';
import type { FileWithPath } from 'react-dropzone';

/**
 * Снимок файла для внутреннего накопителя DropZone.
 *
 * `path` берётся проверкой наличия поля, а не приведением типа: сигнатура
 * `onAdd` в react-dropzone 20 обещает лишь `File`, и приведение соврало бы про
 * источник, из которого файл мог прийти помимо dropzone. Через DOM-сценарии
 * поле есть всегда — `file-selector` дописывает его каждому файлу, прошедшему
 * через `fromEvent`, — поэтому ветка без `path` и проверяется здесь напрямую,
 * а не через рендер компонента.
 */
export const fileToFileObject = (file: File): FileObject => {
  return {
    name: file.name,
    type: file.type,
    size: file.size,
    path: 'path' in file ? (file as FileWithPath).path : undefined,
    lastModified: file.lastModified,
    webkitRelativePath: file.webkitRelativePath,
  };
};
